<template>
  <v-row>
    <v-col cols="12">
      <h2>Check-in summary</h2>
      <v-simple-table>
        <thead>
          <tr>
            <th></th>
            <th>
              Last Check-in {{ lastAssessment.node.assessmentDate }}
              <br />
              <b>Calculation Last vs initial assessment</b>
            </th>
            <th>
              Since 2nd last Check-in {{ previousAssessment && previousAssessment.node.assessmentDate }}
              <br />
              <b>Calculation Last vs previous assessment</b>
            </th>
            <th>Starting Check-in {{ firstAssessment.node.assessmentDate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Weight</td>
            <td>
              {{ lastAssessment.node.weight }} kg
              <br />
              {{ (firstAssessment.node.weight - lastAssessment.node.weight) | formatDecimals }} kg
            </td>
            <td>
              <template v-if="previousAssessment">
                {{ previousAssessment.node.weight }} kg
                <br />
                {{ (previousAssessment.node.weight - lastAssessment.node.weight) | formatDecimals }} kg
              </template>
            </td>
            <td>{{ firstAssessment.node.weight }} kg</td>
          </tr>

          <tr>
            <td>
              Chest
            </td>
            <td>
              {{ lastAssessment.node.chest }} cm
              <br />
              {{ (firstAssessment.node.chest - lastAssessment.node.chest) | formatDecimals }} cm
            </td>
            <td>
              <template v-if="previousAssessment">
                {{ previousAssessment.node.chest }} cm
                <br />
                {{ (previousAssessment.node.chest - lastAssessment.node.chest) | formatDecimals }} cm
              </template>
            </td>
            <td>{{ firstAssessment.node.chest }} cm</td>
          </tr>
          <tr>
            <td>
              Abdomen
            </td>
            <td>
              {{ lastAssessment.node.abdomen }} cm
              <br />
              {{ (firstAssessment.node.abdomen - lastAssessment.node.abdomen) | formatDecimals }} cm
            </td>
            <td>
              <template v-if="previousAssessment">
                {{ previousAssessment.node.abdomen }} cm
                <br />
                {{ (previousAssessment.node.abdomen - lastAssessment.node.abdomen) | formatDecimals }} cm
              </template>
            </td>
            <td>{{ firstAssessment.node.abdomen }} cm</td>
          </tr>
          <tr>
            <td>
              Hip
            </td>
            <td>
              {{ lastAssessment.node.hip }} cm
              <br />
              {{ (firstAssessment.node.hip - lastAssessment.node.hip) | formatDecimals }} cm
            </td>
            <td>
              <template v-if="previousAssessment">
                {{ previousAssessment.node.hip }} cm
                <br />
                {{ (previousAssessment.node.hip - lastAssessment.node.hip) | formatDecimals }} cm
              </template>
            </td>

            <td>{{ firstAssessment.node.hip }} cm</td>
          </tr>
          <tr>
            <td>
              quad
            </td>

            <td>
              {{ lastAssessment.node.quad }} cm
              <br />
              {{ (firstAssessment.node.quad - lastAssessment.node.quad) | formatDecimals }} cm
            </td>
            <td>
              <template v-if="previousAssessment">
                {{ previousAssessment.node.quad }} cm
                <br />
                {{ (previousAssessment.node.quad - lastAssessment.node.quad) | formatDecimals }} cm
              </template>
            </td>

            <td>{{ firstAssessment.node.quad }} cm</td>
          </tr>
          <tr>
            <td></td>
            <td>Initial vs last assessment</td>
            <td>Previous vs last assessment</td>
            <td></td>
          </tr>
          <tr>
            <td>
              Front
            </td>

            <td>
              <div class="d-flex justify-start image-size-container">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-img
                      v-if="firstAssessment.node.imgFront"
                      :src="firstAssessment.node.imgFront"
                      height="180px"
                      contain
                      class="pointer"
                      v-bind="attrs"
                      v-on="on"
                      @click="
                        download(
                          firstAssessment.node.imgFront,
                          `${firstAssessment.node.user.firstName}-${firstAssessment.node.user.lastName}-initial-front`
                        )
                      "
                    />
                  </template>
                  <span>Click to Download</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-img
                      v-if="lastAssessment.node.imgFront"
                      class="pointer"
                      :src="lastAssessment.node.imgFront"
                      @click="
                        download(
                          lastAssessment.node.imgFront,
                          `${lastAssessment.node.user.firstName}-${lastAssessment.node.user.lastName}-current-front`
                        )
                      "
                      height="180px"
                      v-bind="attrs"
                      v-on="on"
                      contain
                    />
                  </template>
                  <span>Click to Download</span>
                </v-tooltip>
              </div>
            </td>
            <td>
              <div class="d-flex justify-start image-size-container">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-img
                      v-if="previousAssessment"
                      class="pointer"
                      :src="previousAssessment.node.imgFront"
                      @click="
                        download(
                          previousAssessment.node.imgFront,
                          `${previousAssessment.node.user.firstName}-${previousAssessment.node.user.lastName}-previous-front`
                        )
                      "
                      v-bind="attrs"
                      v-on="on"
                      height="180px"
                      contain
                    />
                  </template>
                  <span>Click to Download</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-img
                      v-if="lastAssessment.node.imgFront"
                      class="pointer"
                      :src="lastAssessment.node.imgFront"
                      @click="
                        download(
                          lastAssessment.node.imgFront,
                          `${lastAssessment.node.user.firstName}-${lastAssessment.node.user.lastName}-current-front`
                        )
                      "
                      v-bind="attrs"
                      v-on="on"
                      height="180px"
                      contain
                    />
                  </template>
                  <span>Click to Download</span>
                </v-tooltip>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              Back
            </td>

            <td>
              <div class="d-flex justify-start image-size-container">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-img
                      v-if="firstAssessment.node.imgBack"
                      :src="firstAssessment.node.imgBack"
                      class="pointer"
                      height="180px"
                      v-bind="attrs"
                      v-on="on"
                      contain
                      @click="
                        download(
                          firstAssessment.node.imgBack,
                          `${firstAssessment.node.user.firstName}-${firstAssessment.node.user.lastName}-initial-back`
                        )
                      "
                    />
                  </template>
                  <span>Click to Download</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-img
                      v-if="lastAssessment.node.imgBack"
                      :src="lastAssessment.node.imgBack"
                      class="pointer"
                      @click="
                        download(
                          lastAssessment.node.imgBack,
                          `${lastAssessment.node.user.firstName}-${lastAssessment.node.user.lastName}-current-back`
                        )
                      "
                      height="180px"
                      v-bind="attrs"
                      v-on="on"
                      contain
                    />
                  </template>
                  <span>Click to Download</span>
                </v-tooltip>
              </div>
            </td>
            <td>
              <div class="d-flex justify-start image-size-container">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-img
                      v-if="previousAssessment"
                      :src="previousAssessment.node.imgBack"
                      class="pointer"
                      @click="
                        download(
                          previousAssessment.node.imgBack,
                          `${previousAssessment.node.user.firstName}-${previousAssessment.node.user.lastName}-previous-back`
                        )
                      "
                      height="180px"
                      v-bind="attrs"
                      v-on="on"
                      contain
                    />
                  </template>
                  <span>Click to Download</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-img
                      v-if="lastAssessment.node.imgBack"
                      :src="lastAssessment.node.imgBack"
                      class="pointer"
                      @click="
                        download(
                          lastAssessment.node.imgBack,
                          `${lastAssessment.node.user.firstName}-${lastAssessment.node.user.lastName}-current-back`
                        )
                      "
                      height="180px"
                      v-bind="attrs"
                      v-on="on"
                      contain
                    />
                  </template>
                  <span>Click to Download</span>
                </v-tooltip>
              </div>
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              Side
            </td>
            <td>
              <div class="d-flex justify-start image-size-container">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-img
                      v-if="firstAssessment.node.imgSide"
                      :src="firstAssessment.node.imgSide"
                      class="pointer"
                      height="180px"
                      v-bind="attrs"
                      v-on="on"
                      contain
                      @click="
                        download(
                          firstAssessment.node.imgSide,
                          `${firstAssessment.node.user.firstName}-${firstAssessment.node.user.lastName}-initial-side`
                        )
                      "
                    />
                  </template>
                  <span>Click to Download</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-img
                      v-if="lastAssessment.node.imgSide"
                      :src="lastAssessment.node.imgSide"
                      class="pointer"
                      v-bind="attrs"
                      v-on="on"
                      @click="
                        download(
                          lastAssessment.node.imgSide,
                          `${lastAssessment.node.user.firstName}-${lastAssessment.node.user.lastName}-current-side`
                        )
                      "
                      height="180px"
                      contain
                    />
                  </template>
                  <span>Click to Download</span>
                </v-tooltip>
              </div>
            </td>
            <td>
              <div class="d-flex justify-start image-size-container">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-img
                      v-if="previousAssessment"
                      :src="previousAssessment.node.imgSide"
                      class="pointer"
                      @click="
                        download(
                          previousAssessment.node.imgSide,
                          `${previousAssessment.node.user.firstName}-${previousAssessment.node.user.lastName}-previous-side`
                        )
                      "
                      height="180px"
                      v-bind="attrs"
                      v-on="on"
                      contain
                    />
                  </template>
                  <span>Click to Download</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-img
                      v-if="lastAssessment.node.imgSide"
                      :src="lastAssessment.node.imgSide"
                      class="pointer"
                      @click="
                        download(
                          lastAssessment.node.imgSide,
                          `${lastAssessment.node.user.firstName}-${lastAssessment.node.user.lastName}-current-side`
                        )
                      "
                      height="180px"
                      v-bind="attrs"
                      v-on="on"
                      contain
                    />
                  </template>
                  <span>Click to Download</span>
                </v-tooltip>
              </div>
            </td>
            <td></td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-col>
    <v-col cols="12">
      <highcharts v-if="assessmentCount > 1" :options="checkInReport"></highcharts>
    </v-col>
  </v-row>
</template>

<script>
import FileDownloadMixin from "@/components/shared/mixins/FileDownloadMixin";
export default {
  name: "AssessmentSummary",
  props: ["orderedAssessments"],
  mixins: [FileDownloadMixin],
  filters: {
    formatDecimals(value) {
      let rounded = (Math.round((value + Number.EPSILON) * 100) / 100).toString();

      //show the loss or gain, which is inversion of the difference
      // if negative difference, invert and explicitly show +
      // if positive difference explicitly show -
      return rounded[0] == "-" ? `+ ${rounded * -1}` : `- ${rounded}`;
    },
  },
  computed: {
    firstAssessment() {
      let len = this.orderedAssessments.length - 1;
      return this.orderedAssessments[len];
    },
    lastAssessment() {
      return this.orderedAssessments[0];
    },
    previousAssessment() {
      if (this.assessmentCount > 1) {
        return this.orderedAssessments[1];
      }
      return null;
    },
    assessmentCount() {
      return this.orderedAssessments.length;
    },
    checkInReport() {
      var dates = [];
      var data = {
        weight: [],
        abdomen: [],
        chest: [],
        hip: [],
        quad: [],
      };

      this.orderedAssessments.forEach((assessment) => {
        dates.unshift(this.$moment(assessment.node.assessmentDate).format("YYYY-MM-DD"));
        data["weight"].unshift([
          this.$moment(assessment.node.assessmentDate).format("YYYY-MM-DD"),
          parseFloat(assessment.node.weight),
        ]);
        data["abdomen"].unshift([
          this.$moment(assessment.node.assessmentDate).format("YYYY-MM-DD"),
          parseFloat(assessment.node.abdomen),
        ]);
        data["chest"].unshift([
          this.$moment(assessment.node.assessmentDate).format("YYYY-MM-DD"),
          parseFloat(assessment.node.chest),
        ]);
        data["hip"].unshift([
          this.$moment(assessment.node.assessmentDate).format("YYYY-MM-DD"),
          parseFloat(assessment.node.hip),
        ]);
        data["quad"].unshift([
          this.$moment(assessment.node.assessmentDate).format("YYYY-MM-DD"),
          parseFloat(assessment.node.quad),
        ]);
      });

      return {
        chart: {
          type: "line",
        },
        title: {
          text: "Check-in summary",
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          categories: dates,
        },
        yAxis: {
          min: 0,
        },
        series: [
          {
            name: "Weight",
            data: data["weight"],
            color: "green",
            tooltip: {
              valueDecimals: 2,
              pointFormatter: function() {
                let y = this.y;
                var difference = 0;
                var total = 0;
                if (this.x > 0) {
                  difference = this.series.points[this.x].y - this.series.points[this.x - 1].y;
                  total = this.series.points[this.x].y - this.series.points[0].y;

                  return (
                    this.series.points[this.x].y +
                    " kg <br/> Change since last check-in: <b>" +
                    difference.toFixed(2) +
                    "</b><br/> Change since first check-in: <b>" +
                    total.toFixed(2) +
                    "</b>"
                  );
                } else {
                  return this.series.points[this.x].y + "kg";
                }
              },
            },
          },
          {
            name: "Chest",
            data: data["chest"],
            color: "purple",
            tooltip: {
              valueDecimals: 2,
              pointFormatter: function() {
                let y = this.y;
                var difference = 0;
                var total = 0;
                if (this.x > 0) {
                  difference = this.series.points[this.x].y - this.series.points[this.x - 1].y;
                  total = this.series.points[this.x].y - this.series.points[0].y;

                  return (
                    this.series.points[this.x].y +
                    " cm <br/> Change since last check-in: <b>" +
                    difference.toFixed(2) +
                    "</b><br/> Change since first check-in: <b>" +
                    total.toFixed(2) +
                    "</b>"
                  );
                } else {
                  return this.series.points[this.x].y + "cm";
                }
              },
            },
          },
          {
            name: "Abdomen",
            data: data["abdomen"],
            color: "blue",
            tooltip: {
              valueDecimals: 2,
              pointFormatter: function() {
                let y = this.y;
                var difference = 0;
                var total = 0;
                if (this.x > 0) {
                  difference = this.series.points[this.x].y - this.series.points[this.x - 1].y;
                  total = this.series.points[this.x].y - this.series.points[0].y;

                  return (
                    this.series.points[this.x].y +
                    " cm <br/> Change since last check-in: <b>" +
                    difference.toFixed(2) +
                    "</b><br/> Change since first check-in: <b>" +
                    total.toFixed(2) +
                    "</b>"
                  );
                } else {
                  return this.series.points[this.x].y + "cm";
                }
              },
            },
          },
          {
            name: "Hip",
            data: data["hip"],
            color: "cyan",
            tooltip: {
              valueDecimals: 2,
              pointFormatter: function() {
                let y = this.y;
                var difference = 0;
                var total = 0;
                if (this.x > 0) {
                  difference = this.series.points[this.x].y - this.series.points[this.x - 1].y;
                  total = this.series.points[this.x].y - this.series.points[0].y;

                  return (
                    this.series.points[this.x].y +
                    " cm <br/> Change since last check-in: <b>" +
                    difference.toFixed(2) +
                    "</b><br/> Change since first check-in: <b>" +
                    total.toFixed(2) +
                    "</b>"
                  );
                } else {
                  return this.series.points[this.x].y + "cm";
                }
              },
            },
          },
          {
            name: "Quad",
            data: data["quad"],
            color: "pink",
            tooltip: {
              valueDecimals: 2,
              pointFormatter: function() {
                let y = this.y;
                var difference = 0;
                var total = 0;
                if (this.x > 0) {
                  difference = this.series.points[this.x].y - this.series.points[this.x - 1].y;
                  total = this.series.points[this.x].y - this.series.points[0].y;

                  return (
                    this.series.points[this.x].y +
                    " cm <br/> Change since last check-in: <b>" +
                    difference.toFixed(2) +
                    "</b><br/> Change since first check-in: <b>" +
                    total.toFixed(2) +
                    "</b>"
                  );
                } else {
                  return this.series.points[this.x].y + "cm";
                }
              },
            },
          },
        ],
      };
    },
  },
};
</script>

<style scoped>
.image-size-container {
  max-width: 150px;
}
</style>
